import { openapi_website_cms_resetFilter, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_resetFilter';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type ResetFiltersType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface ResetFiltersParamsType {
    sportName: string,
    newFilters: Array<{
        display_order: number,
        filter_name: string,
        filter_slug: string,
        sport_name: string,
    }>
}

export const resetFilters = {
    browser: {
        params: (params: ResetFiltersParamsType): ParamsFetchType<ResetFiltersParamsType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/market-filters/reset',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/market-filters/reset',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<ResetFiltersParamsType>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_resetFilter(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            sport: params.req.body.sportName,
            body: params.req.body.newFilters
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
